import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});
const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['725'] }
];

const tableStructure = [
    {id: 'conceptoNombre', title: 'Concepto'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  pagador: string;
  origen: string;
  concepto: string;
  conceptoNombre: string;
  tipoRenta: string;
  rentaNombre: string;
  valor: string;
  seccionOrigen: string;
  ingresoExt:string;
  impuestoExt:string;
/*   limDepen:string; */
  lim4xmil:string;
  limInterIce:string;
  deshabilitarAcci:boolean
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-beneficios-tributarios-descuentos-modal',
  templateUrl: './beneficios-tributarios-descuentos-modal.component.html',
  styleUrls: ['./beneficios-tributarios-descuentos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class BeneficiosTributariosDescuentosModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listaMeses: number[] =  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];;

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  //listaTipoRenta:any;

  //model:DDocumento;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  uvt: string;
  listConcDescTrib = [];
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<BeneficiosTributariosDescuentosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(this.model);
  //  this.model = this.data.model;
    //this.model = this.data;
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.inicializeTablaDesdeIngresos();
    //this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    this.listConcDescTrib.forEach(item => {
      item.mostrar = true;
      if(item.valor==1 || item.valor==2){
        item.mostrar = false;
      }
    }); 

  }

  protected controlStep(direction: DirectionType): void {
  
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.concepto="0";
    this.modelForm.conceptoNombre="";
    this.modelForm.valor="0";
    this.modelForm.ingresoExt="0";
    this.modelForm.impuestoExt="0";
    this.modelForm.origen="";
    this.modelForm.seccionOrigen="";


  }
  
  protected inicializeModelo(){
   /*  if(this.model.doc.cuerpo.cc_id_726 == undefined){

      this.model.doc.cuerpo.cc_id_726 = []; //concepto
      this.model.doc.cuerpo.cc_id_736 = []; //ingresoExt
      this.model.doc.cuerpo.cc_id_737 = []; //impuestoExt
      this.model.doc.cuerpo.cc_id_727 = []; //valor
      this.model.doc.cuerpo.cc_id_735 = []; //seccionOrigen
      this.model.doc.cuerpo.cs_id_728 = "0";//total
    } */
    if(this.model.doc.cuerpo.cc_id_726 == undefined) this.model.doc.cuerpo.cc_id_726 = []; //concepto
    if(this.model.doc.cuerpo.cc_id_727 == undefined) this.model.doc.cuerpo.cc_id_727 = []; //valor
    if(this.model.doc.cuerpo.cc_id_736 == undefined) this.model.doc.cuerpo.cc_id_736 = []; //ingresoExt
    if(this.model.doc.cuerpo.cc_id_737 == undefined) this.model.doc.cuerpo.cc_id_737 = []; //impuestoExt
    if(this.model.doc.cuerpo.cc_id_735 == undefined) this.model.doc.cuerpo.cc_id_735 = []; //seccionOrigen
    if(this.model.doc.cuerpo.cs_id_728 == undefined) this.model.doc.cuerpo.cs_id_728 = "0"; //total
  }
  
  protected inicializeTablaDesdeIngresos(){
    this.obtenerEliminarOtrasSecciones('I5');
    this.obtenerEliminarOtrasSecciones('I7');
    this.obtenerEliminarOtrasSecciones('I8');
    this.obtenerEliminarOtrasSecciones('I9'); 
    this.obtenerEliminarOtrasSecciones('I13');
    this.inizializeData(true,'cc_id_361','I5'); //pension o indemnizacion
    this.inizializeData(true,'cc_id_501','I7'); //dividendos y participaciones
    this.inizializeData(true,'cc_id_521','I8','cc_id_508'); //venta de vivienda
    this.inizializeData(true,'cc_id_554','I9','cc_id_546'); //venta de activos fijos
    this.inizializeData(true,'cc_id_631','I13'); //rentas pasivas ECE
   
  }

  inizializeData(desdeSeccion:boolean, casValor:string, seccionOrigen:string, casValorAdi?:string){
    const array = this.model.doc.cuerpo[casValor];
    if(array != undefined && array != null){
         
        let posImptos = [];
        for(let i=0; i<array.length; i++){
          if(casValorAdi != undefined && casValorAdi != null && casValorAdi != ""){ 
            if(this.model.doc.cuerpo[casValorAdi].length > 0){
              if(array[i].v > "0" && this.model.doc.cuerpo[casValorAdi][i].v == "2"){
                posImptos.push(i);
              }
            }
            
          }else{
            if(array[i].v > "0"){
              posImptos.push(i);
            }
          }
          
        } 
  
        let index = desdeSeccion ? this.dataSourceBody.length : this.model.doc.cuerpo.cc_id_726.length;
        if(posImptos.length > 0)
        {
          if(!desdeSeccion) this.inicializeForm();
  
          for(let i=0; i<posImptos.length; i++)
          {
            const indexImpPens = posImptos[i];
          //  const existeValor = this.model.doc.cuerpo.cc_id_727.some(item => item.v === array[indexImpPens].v);
            //if(!existeValor){
              
              this.modelForm.id=index;
              this.modelForm.concepto="1";
              this.modelForm.valor=array[indexImpPens].v;
              this.modelForm.conceptoNombre= desdeSeccion ? this.listConcDescTrib[0].nombre : ''; 
              this.modelForm.seccionOrigen=seccionOrigen;
              this.modelForm.deshabilitarAcci=true;
              this.redondearFormData();
              if(!desdeSeccion)
                this.addToModeloDesdeForm();
              else{
                this.dataSourceBody.push(this.modelForm);
                this.addToModeloDesdeForm();

              }
  
              this.inicializeForm();
              index++;
           // }
            
          }
          
        }
        if(desdeSeccion)
          this.operacionCs728();
        else
        this.operacionCs728DesdeIngresos();    
  
    };
  }  

  actualizarDataPen(){
    this.obtenerEliminarOtrasSecciones('I5');
    this.inizializeData(false,'cc_id_361','I5');
  }

  actualizarDataDivi(){
    this.obtenerEliminarOtrasSecciones('I7');
    this.inizializeData(false,'cc_id_501','I7');
  }

  actualizarDataVenVivi(){
    this.obtenerEliminarOtrasSecciones('I8');
    this.inizializeData(false,'cc_id_521','I8','cc_id_508');
  }

  actualizarDataActiFijo(){
    this.obtenerEliminarOtrasSecciones('I9');
    this.inizializeData(false,'cc_id_554','I9','cc_id_546');
  }

  actualizarDataRentPasi(){
    this.obtenerEliminarOtrasSecciones('I13');
    this.inizializeData(false,'cc_id_631','I13');
  }

  obtenerEliminarOtrasSecciones(seccionOrigen:string){
    if(this.model.doc.cuerpo.cc_id_735 != undefined 
      && this.model.doc.cuerpo.cc_id_735 != null){
  
        const posicionesPensiones = this.model.doc.cuerpo.cc_id_735.reduce((acc, item, index) => {
          if (item.v == seccionOrigen) {
              acc.push(index);
          }
          return acc;
      }, []);
  
  
      posicionesPensiones.sort((a, b) => b - a).forEach(index => {
        this.model.doc.cuerpo.cc_id_726.splice(index, 1); //concepto
        this.model.doc.cuerpo.cc_id_727.splice(index, 1); //valor
        this.model.doc.cuerpo.cc_id_736.splice(index, 1); //ingresoExt
        this.model.doc.cuerpo.cc_id_737.splice(index, 1); //impuestoExt
        this.model.doc.cuerpo.cc_id_735.splice(index, 1); //seccionOrigen
        this.dataSourceBody.splice(index, 1);

      });
  
    } 
  }

 

  public operacionCs728(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
     
    if(suma)
      this.model.doc.cuerpo.cs_id_728 = suma;
    else
      this.model.doc.cuerpo.cs_id_728 = '0';  

  }

  public operacionCs728DesdeIngresos(){
    let suma = "0";
    for(let i=0; i<this.model.doc.cuerpo.cc_id_727.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_727[i].v, suma);
    
    }
     
    if(suma)
      this.model.doc.cuerpo.cs_id_728 = suma;
    else
      this.model.doc.cuerpo.cs_id_728 = '0'; 
  }

  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_726.length; i++){
      this.modelForm.id=i;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_726[i].v;
      this.modelForm.conceptoNombre=this.listConcDescTrib[this.model.doc.cuerpo.cc_id_726[i].v-1].nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_727[i].v;
      this.modelForm.ingresoExt=this.model.doc.cuerpo.cc_id_736[i].v;
      this.modelForm.impuestoExt=this.model.doc.cuerpo.cc_id_737[i].v;
      this.modelForm.seccionOrigen=this.model.doc.cuerpo.cc_id_735[i].v;
      this.modelForm.deshabilitarAcci=this.modelForm.seccionOrigen != "" ? true : false;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
 /*  let indexModel = this.model.doc.cuerpo.cc_id_726.length;
  if(this.data.sugerida)
  {
    for(let i=0; i<this.data.sugerida.length; i++)
    {
      const existeValor = this.model.doc.cuerpo.cc_id_726.some(item => item.v === this.data.sugerida[i].pagador);

      if(!existeValor){
        
        this.modelForm.id=indexModel;
        this.modelForm.pagador=this.data.sugerida[i].pagador;
        this.modelForm.tipoRenta=this.data.sugerida[i].tipoRenta;
        this.modelForm.rentaNombre= this.listaTipoRenta[this.data.sugerida[i].tipoRenta-1].nombre; 
        this.modelForm.valor=this.data.sugerida[i].valor;
        this.modelForm.concepto=this.data.sugerida[i].concepto;
        this.modelForm.conceptoNombre= this.listConcDescTrib[this.data.sugerida[i].concepto-1].nombre; 
        this.modelForm.origen="0";
        this.modelForm.deshabilitarAcci=false;

        this.calcularLim4xmil();
        this.calcularLimInterIce();
        this.calcularingresoExt();
        this.calcularimpuestoExt();
        this.redondearFormData();
        this.reloadListTipoRent();
        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
        indexModel++;
      }
      
    }
    
  }

    this.operacionCs728(); */
}

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_726[this.modelForm.id].v=this.modelForm.concepto;
    this.model.doc.cuerpo.cc_id_727[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_736[this.modelForm.id].v=this.modelForm.ingresoExt.toString();
    this.model.doc.cuerpo.cc_id_737[this.modelForm.id].v=this.modelForm.impuestoExt.toString();
   /*  this.model.doc.cuerpo.cc_id_713[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_719[this.modelForm.id].v=this.modelForm.ingresoExt.toString();
    this.model.doc.cuerpo.cc_id_720[this.modelForm.id].v=this.modelForm.impuestoExt.toString(); */
    //this.model.doc.cuerpo.cc_id_721[this.modelForm.id].v=this.modelForm.limDepen.toString();
  /*   this.model.doc.cuerpo.cc_id_721[this.modelForm.id].v=this.modelForm.seccionOrigen.toString();
    this.model.doc.cuerpo.cc_id_722[this.modelForm.id].v=this.modelForm.lim4xmil.toString();
    this.model.doc.cuerpo.cc_id_723[this.modelForm.id].v=this.modelForm.limInterIce.toString(); */

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_726.push({it: i, v:this.modelForm.concepto});
    this.model.doc.cuerpo.cc_id_727.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_735.push({it: i, v:this.modelForm.seccionOrigen.toString()});
    this.model.doc.cuerpo.cc_id_736.push({it: i, v:this.modelForm.ingresoExt.toString()});
    this.model.doc.cuerpo.cc_id_737.push({it: i, v:this.modelForm.impuestoExt.toString()});
   /*  this.model.doc.cuerpo.cc_id_713.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_719.push({it: i, v:this.modelForm.ingresoExt.toString()});
    this.model.doc.cuerpo.cc_id_720.push({it: i, v:this.modelForm.impuestoExt.toString()});
    this.model.doc.cuerpo.cc_id_721.push({it: i, v:this.modelForm.seccionOrigen.toString()});
    //this.model.doc.cuerpo.cc_id_721.push({it: i, v:this.modelForm.limDepen.toString()});
    this.model.doc.cuerpo.cc_id_722.push({it: i, v:this.modelForm.lim4xmil.toString()});
    this.model.doc.cuerpo.cc_id_723.push({it: i, v:this.modelForm.limInterIce.toString()}); */

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_726.splice(index,1);
    this.model.doc.cuerpo.cc_id_727.splice(index,1);
    this.model.doc.cuerpo.cc_id_735.splice(index,1);
    this.model.doc.cuerpo.cc_id_736.splice(index,1);
    this.model.doc.cuerpo.cc_id_737.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_726.length;i++){
      this.model.doc.cuerpo.cc_id_726[i].it=i+1;
      this.model.doc.cuerpo.cc_id_727[i].it=i+1;
      this.model.doc.cuerpo.cc_id_735[i].it=i+1;
      this.model.doc.cuerpo.cc_id_736[i].it=i+1;
      this.model.doc.cuerpo.cc_id_737[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.concepto==undefined || this.modelForm.concepto==null  || this.modelForm.concepto=="0" ||  
         this.modelForm.valor==undefined || this.modelForm.valor==null 
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.ingresoExt=this.dutilidades.redondearValorMoneda(this.modelForm.ingresoExt.toString(),true);
    this.modelForm.impuestoExt=this.dutilidades.redondearValorMoneda(this.modelForm.impuestoExt.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }

  reloadListConceptos(){
    const valorTipoRenta = this.modelForm.tipoRenta;
   /*  1 - Rentas de trabajo sin costo
2 - Rentas de trabajo con costo
3 - Rentas de capital
4 -  Rentas no laborales
5 - Pensión
6 - Dividendos
7 - GO

1 Renta de trabajo sin costo,
2 Renta de trabajo con costo
3 Rentas de Capital
4 Renta no laborales",
*/

/*Intereses préstamos compra vivienda
Intereses préstamos  ICETEX
Medicina prepagada y seguro de salud
GMF 4 X 1000
Aportes a Cesantías */

/*     this.listConcDescTrib.forEach(item => {
      item.mostrar = true;
      if((valorTipoRenta=="1" || valorTipoRenta=="2") && item.valor==5){
        item.mostrar = false;
      }else if((valorTipoRenta=="3" || valorTipoRenta=="4") && item.valor==2){
        item.mostrar=false;
      }

    }); */

  }

  reloadListTipoRent(){
    const concepto = this.modelForm.concepto;
  /*   this.listaTipoRenta.forEach(item => {
      item.mostrar = false;
      if((concepto=="1" || concepto=="2" || concepto=="4")){
        item.mostrar=true;
      }else if(concepto=="3" && (item.valor==1 || item.valor==2)){
        item.mostrar=true;
      }else if(concepto=="5" && (item.valor==3 || item.valor==4)){
        item.mostrar=true;
      }
    }); */
      

  }

  calcularimpuestoExt(){
    const valor = this.modelForm.valor;
    const valorUVT = this.convertirPesosUvt(valor);
    const limInteMediPrep = "192";
    const limInteMediPrepPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInteMediPrep, true);
    const tipoRenta = this.modelForm.tipoRenta;

    if(tipoRenta=="1" || tipoRenta=="2"){
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limInteMediPrep)){ 
        this.modelForm.impuestoExt=valor;
      }else{
        this.modelForm.impuestoExt=limInteMediPrepPesos;
      }
    }else{
      this.modelForm.impuestoExt="";

    }
    
  }

  calcularingresoExt(){
    const valor = this.modelForm.valor;
    const valorUVT = this.convertirPesosUvt(valor);
    const limInteViviendaUVT = "1200";
    const limInteViviendaPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInteViviendaUVT, true);
 
     if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, valorUVT, limInteViviendaUVT)){ 
      this.modelForm.ingresoExt=valor;
    }else{
      this.modelForm.ingresoExt=limInteViviendaPesos
    } 
  }

  calcularLim4xmil(){
    const valor = this.modelForm.valor;
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    if((tipoRenta=="1" || tipoRenta=="2" || tipoRenta=="3") && concepto=="4"){
      this.modelForm.lim4xmil=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.5");
    }else{
      this.modelForm.lim4xmil="";
    }
  }

  calcularLimInterIce(){
    const concepto = this.modelForm.concepto; 
    
    if(concepto=="2"){
      const valor = this.modelForm.valor; 
      const valorUVT = this.convertirPesosUvt(valor);
      const limInterIceUVT = "100";
      const limInterIcePesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInterIceUVT, true);
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limInterIceUVT))
        this.modelForm.limInterIce=valor;
      else
      this.modelForm.limInterIce=limInterIcePesos;
    }else
      this.modelForm.limInterIce="";
    
  }

  
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.uvt);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        const existeValor = this.model.doc.cuerpo.cc_id_726.some(item => item.v === this.modelForm.concepto);
        //this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre;
        this.modelForm.conceptoNombre = this.listConcDescTrib[Number(this.modelForm.concepto)-1].nombre;
        
        this.limit25pctConcept3();//Si Cas 726 = 3; Cas 727 <o= Cas 727 * 0.25 debe restringir lo que digite al 25%
          
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_726.length;
        this.modelForm.origen = "2";
      //  this.modelForm.reportante = "Contribuyente";
        //this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre;
        this.modelForm.conceptoNombre = this.listConcDescTrib[Number(this.modelForm.concepto)-1].nombre;

        this.limit25pctConcept3();//Si Cas 726 = 3; Cas 727 <o= Cas 727 * 0.25 debe restringir lo que digite al 25%

        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs728();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  private limit25pctConcept3() {
    if (this.modelForm.concepto == '3') {
      this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valor, '0.25');
    }
    this.modelForm.valor=this.dutilidades.obtenerFormatoMoneda(this.modelForm.valor);
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs728();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      
      this.modelForm = this.dataSourceBody[index];
      this.reloadListTipoRent();
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }



  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    /* this.changeStepLocal(0); */
    this.initializeTablaDesdeModelo();
    this.operacionCs728();
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla

    this.model.doc.cuerpo.cc_id_726 = [] //concepto
    this.model.doc.cuerpo.cc_id_727 = [] //valor
    this.model.doc.cuerpo.cc_id_736 = [] //ingresoExt
    this.model.doc.cuerpo.cc_id_737 = [] //impuestoExt
    this.model.doc.cuerpo.cc_id_735 = [] //seccionOrigen
    this.model.doc.cuerpo.cs_id_728 = "0"; //total
   
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs728();

    this.saveModel.emit(true); 
    this.closeModal();   
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component.ts